/**
 * Primary app navigation — the single source of truth for both the desktop
 * topbar (`.topnav` in App.jsx) and the mobile drawer (MobileNav.jsx).
 *
 * Adding a destination here puts it in both places automatically, so the two
 * navs can't drift apart. `isActive` takes `location.pathname`; the rules are
 * deliberately not uniform — `/projects` and `/posts` have detail routes
 * beneath them that should keep the parent lit, `/dashboard` and `/inbox`
 * are leaves.
 */
export const NAV_ITEMS = [
  { to: '/dashboard', icon: '📊', label: 'Dashboard', isActive: (p) => p === '/dashboard' },
  { to: '/projects', icon: '📁', label: 'Projects', isActive: (p) => p.startsWith('/projects') },
  { to: '/posts', icon: '📰', label: 'Posts', isActive: (p) => p.startsWith('/posts') },
  { to: '/inbox', icon: '✅', label: 'Inbox', isActive: (p) => p === '/inbox' },
];
